module.exports = __webpack_public_path__ + "media/components/client_connexion/static/Riing-6c02ad4d033d1868d450bb57435aa672.png";